import Layout from '@layout/Index'

export const orderReview = [
  {
    path: '/order',
    component: Layout,
    children: [
      {
        path: 'review/:id',
        component: () => import(/* webpackChunkName: "order-review */ './pages/OrderReview.vue'),
        name: '订单审核',
        meta: {
          title: '订单审核',
        },
      },
      {
        path: 'review-audit-quality/:id',
        component: () => import(/* webpackChunkName: "review-audit-quality" */ './pages/OrderReview.vue'),
        name: '复核审单结果',
        meta: {
          title: '复核审单结果',
          pageType: 'reviewAuditQuality',
        },
      },
      {
        path: 'review-audit-quality-detail/:id',
        component: () => import(/* webpackChunkName: "review-audit-quality" */ './pages/OrderReview.vue'),
        name: '查看审单复核结果',
        meta: {
          title: '查看审单复核结果',
          pageType: 'viewReviewAuditQuality',
        },
      },
    ],
  },
  {
    path: '/clb-order',
    component: Layout,
    children: [
      {
        path: 'review/:id',
        component: () => import(/* webpackChunkName: "order-review */ './pages/OrderReview.vue'),
        name: '查理宝订单审核',
        meta: {
          title: '查理宝订单审核',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/order-review/order-review.route.js